import React, { useEffect, useState, useMemo } from 'react';
import SetDepthSummary from './set-depth-summary';
import RecommendedParameters from './recommended-parameters';
import Miscellaneous from './miscellaneous';
import EspEquipments from './esp-equipments';
import AccessoriesBelowEsp from './accessories-below-esp';
import AccessoriesAboveESP from './accessories-above-esp';
import SwitchButton from '../../common/switch-button';
import LABELS from '../../../constants/labels/schematics.labels';
import useSchematicFacade from '../../../facade/calculation/calculation-output/schematic.facade';
import { useAppSelector } from '../../../store/hooks/StoreHooks';
import useCalculationFacade from '../../../facade/calculation/calculation.facade';
import Error from '../../../assets/icons/Error';

const Schematics: React.FC = () => {
    const { schematicData } = useAppSelector(state => state?.calculations);
    const { updateShowSchematicDataInMainReport } = useSchematicFacade();
    const { fetchCalculatedSetDepth, updateMotorLoadFrequency ,updateSchematicOtherData} = useCalculationFacade();
    const [ischecked, setIsChecked] = useState(schematicData?.miscellaneous?.showSchematicData ?? false);

    const [showError, setShowError] = useState<boolean>(false);

    const { tab2Input } = useAppSelector(state => state?.wellInput);
    const {
        existedGasSepEquipments,
        existedGasHandlerEquipments,
        existedSRGasPump1Equipments,
        existedSRGasPump2Equipments,
        existedSRGasPump3Equipments,
    } = useAppSelector(state => state?.gasCalculations);
    const { ESPEquipments } = useAppSelector(state => state?.pump);
    const showSchematicData = useMemo(() => schematicData?.miscellaneous?.showSchematicData ?? false, [schematicData?.miscellaneous?.showSchematicData]);

    useEffect(() =>{
        if (ischecked !== showSchematicData) {
            setIsChecked(showSchematicData);
        }
    },[showSchematicData, ischecked])

    useEffect(() => {
        setShowError(false);
        if (tab2Input) {
            const tvd = tab2Input?.tvd ?? 0;
            const gasSepFilter = existedGasSepEquipments?.filter((item: any) => Object?.keys(item).length > 0);
            const gasHandlerFilter = existedGasHandlerEquipments?.filter((item: any) => Object?.keys(item).length > 0);
            const chargePump1Filter = existedSRGasPump1Equipments?.filter((item: any) => Object?.keys(item).length > 0);
            const chargePump2Filter = existedSRGasPump2Equipments?.filter((item: any) => Object?.keys(item).length > 0);
            const chargePump3Filter = existedSRGasPump3Equipments?.filter((item: any) => Object?.keys(item).length > 0);
            const mainPumpFilter = ESPEquipments?.filter((item: any) => Object?.keys(item).length > 0);
            if (
                gasSepFilter?.length > 0 &&
                tvd > gasSepFilter[gasSepFilter?.length - 1]?.setDepth
            ) {
                setShowError(true);
            } else if (gasSepFilter?.length === 0 && gasHandlerFilter) {
                if (
                    gasHandlerFilter?.length > 0 &&
                    tvd > gasHandlerFilter[gasHandlerFilter?.length - 1]?.setDepth
                ) {
                    setShowError(true);
                } else if (gasHandlerFilter?.length === 0 && chargePump1Filter) {
                    if (
                        chargePump1Filter?.length > 0 &&
                        tvd > chargePump1Filter[chargePump1Filter?.length - 1]?.setDepth
                    ) {
                        setShowError(true);
                    } else if (chargePump1Filter?.length === 0 && chargePump2Filter) {
                        if (
                            chargePump2Filter?.length > 0 &&
                            tvd > chargePump2Filter[chargePump2Filter.length - 1]?.setDepth
                        ) {
                            setShowError(true);
                        } else if (chargePump2Filter?.length === 0 && chargePump3Filter) {
                            if (
                                chargePump3Filter?.length > 0 &&
                                tvd > chargePump3Filter[chargePump3Filter?.length - 1]?.setDepth
                            ) {
                                setShowError(true);
                            } else if (chargePump3Filter?.length === 0 && mainPumpFilter) {
                                if (
                                    mainPumpFilter?.length > 0 &&
                                    tvd > mainPumpFilter[mainPumpFilter?.length - 1]?.setDepth
                                ) {
                                    setShowError(true);
                                }
                            }
                        }
                    }
                }
            }
        }

    }, [tab2Input,
        existedGasSepEquipments,
        existedGasHandlerEquipments,
        existedSRGasPump1Equipments,
        existedSRGasPump2Equipments,
        existedSRGasPump3Equipments,
        ESPEquipments])

    const handleToggle = () => {
        const misc = {
            showSchematicData: !ischecked,
        };
        setIsChecked(!ischecked);
        updateSchematicOtherData(misc);
        updateShowSchematicDataInMainReport(!ischecked);
        fetchCalculatedSetDepth();
        updateMotorLoadFrequency();
    };

    return (
        <div className='flex flex-col justify-center item-center w-full h-full gap-[16px]'>
            {
                showError &&
                <div className="flex p-[16px] gap-[12px] rounded-[8px] border-[1px] bg-error-500 border-darkcolor-400 mt-1">
                    <Error className="mr-2" />
                    <p className="text-[14px] font-bold leading-[20px] text-neutral-25">
                        Pump setting VD greater than Pump setting MD
                    </p>
                </div>
            }
            <SwitchButton
                label={LABELS?.includeInMainreport}
                checked={ischecked}
                onChange={handleToggle}
            />
            <AccessoriesAboveESP />
            <EspEquipments />
            <AccessoriesBelowEsp />
            <Miscellaneous />
            <SetDepthSummary />
            <RecommendedParameters />
        </div>
    );
};

export default Schematics;
